// ==========================
// DEFAULT DATA
// ==========================
export const defaultData = {
  mainTitle: "KEY CHALLENGES & STRATEGIC SOLUTIONS",
  mainSubtitle:
    "Addressing critical industry pain points with proven methodologies",

  leftTitle: "Industry Challenges",
  rightTitle: "Our Solutions",

  challenges: [
    {
      icon: "/assets/icons/regulatory.png",
      title: "Regulatory Complexity",
      text: "Navigating evolving environmental regulations and requirements across multiple jurisdictions.",
    },
    {
      icon: "/assets/icons/price.png",
      title: "Price Volatility",
      text: "Managing financial risks from commodity price fluctuations and market uncertainty.",
    },
    {
      icon: "/assets/icons/esg.png",
      title: "ESG Compliance",
      text: "Meeting environmental, social, and governance standards while maintaining operational efficiency.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/strategy.png",
      title: "Strategic Planning",
      text: "Comprehensive regulatory roadmaps and compliance frameworks tailored to your operations.",
    },
    {
      icon: "/assets/icons/risk.png",
      title: "Risk Management",
      text: "Advanced hedging strategies and financial instruments to mitigate market volatility.",
    },
    {
      icon: "/assets/icons/sustainability.png",
      title: "Sustainability Consulting",
      text: "ESG integration strategies that enhance reputation while driving operational excellence.",
    },
  ],
};

// ==========================
// OIL & GAS DATA
// ==========================
export const oilAndGasData = {
  mainTitle: "NAVIGATING OIL & GAS FINANCIAL PRESSURES WITH SMARTER SOLUTIONS",
  mainSubtitle:
    "Every financial hurdle hides an opportunity. We help you unlock it with data-driven digital solutions.",

  leftTitle: "Industry Challenges",
  rightTitle: "Our Solutions",

  challenges: [
    {
      icon: "/assets/icons/cost.png",
      title: "Cost Pressures",
      text: "Oil and gas operations face rising production, labor, and maintenance expenses that impact profitability and slow long-term planning.",
    },
    {
      icon: "/assets/icons/cash.png",
      title: "Cash Volatility",
      text: "Market fluctuations and fragmented data restrict accurate forecasting, create liquidity uncertainty, and delay strategic decision-making.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Compliance Burden",
      text: "Tightening environmental and financial regulations increases administrative workload, documentation pressure, and audit-related costs.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/optimization.png",
      title: "Cost Optimization",
      text: "Automation, digital workflows, and asset monitoring reduce manual overheads and streamline processes.",
    },
    {
      icon: "/assets/icons/insights.png",
      title: "Real-Time Insights",
      text: "Integrated analytics and unified dashboards provide instant visibility across assets and finances.",
    },
    {
      icon: "/assets/icons/auto-compliance.png",
      title: "Automated Compliance",
      text: "Digital tracking, automated reporting, and audit-ready documentation reduce compliance risk.",
    },
  ],
};

// ==========================
// POWER & UTILITIES DATA
// ==========================
export const powerAndUtilitiesData = {
  mainTitle: "EASE INVESTMENT PRESSURE WITH SMARTER FINANCIAL SOLUTIONS",
  mainSubtitle:
    "Clear financial solutions for the sector’s most regulatory challenges.",

  leftTitle: "Industry Challenges",
  rightTitle: "Our Solutions",

  challenges: [
    {
      icon: "/assets/icons/cost.png",
      title: "Cost Volatility",
      text: "Decentralized energy, fluctuating fuel prices, and rising O&M costs strain financial stability.",
    },
    {
      icon: "/assets/icons/grid.png",
      title: "Grid Modernization",
      text: "Ageing networks require heavy capital investment with long payback periods.",
    },
    {
      icon: "/assets/icons/regulatory.png",
      title: "Regulatory Pressure",
      text: "Tariff reforms and compliance mandates are tightening globally.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Margin Stabilization",
      text: "We optimize cost structures and build models that protect profitability under uncertain market conditions.",
    },
    {
      icon: "/assets/icons/capital.png",
      title: "Capital Clarity",
      text: "We design investment frameworks, forecast ROI, and enhance capital allocation to strengthen long-term asset performance.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Compliance Readiness",
      text: "We streamline reporting, ensure regulatory alignment, and prepare utilities for evolving audit and tariff structures.",
    },
  ],
};

// ==========================
// WASTE MANAGEMENT DATA
// ==========================
export const wasteManagementData = {
  mainTitle: "SOLVING TODAY’S WASTE MANAGEMENT CHALLENGES",
  mainSubtitle:
    "Targeted strategies that address the sector’s operational, financial, and regulatory challenges.",

  leftTitle: "Industry Challenges",
  rightTitle: "Our Solutions",

  challenges: [
    {
      icon: "/assets/icons/cost.png",
      title: "Rising Costs",
      text: "Fuel, labour, and processing expenses continue to increase across the sector.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Regulatory Compliance",
      text: "Environmental laws and reporting standards are becoming more demanding.",
    },
    {
      icon: "/assets/icons/volume.png",
      title: "Waste Volumes",
      text: "Growing populations are increasing waste generation and system pressure.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Cost Control",
      text: "We optimize budgeting, operational spending, and financial structures for better margins.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Compliance Support",
      text: "We help organizations align with regulations, audits, and sustainability requirements.",
    },
    {
      icon: "/assets/icons/capacity.png",
      title: "Capacity Planning",
      text: "We build data-led forecasts that guide infrastructure upgrades and investment decisions.",
    },
  ],
};

// ==========================
// MINING & MINERALS DATA
// ==========================
export const miningAndMineralsData = {
  mainTitle: "MINING’S CHALLENGES. OUR STRATEGIC ANSWERS",
  mainSubtitle:
    "Helping mining teams navigate rising demands with clear, actionable, sustainable solutions.",

  leftTitle: "Industry Challenges",
  rightTitle: "Our Solutions",

  challenges: [
    {
      icon: "/assets/icons/price.png",
      title: "Market Volatility",
      text: "Mining companies face unstable commodity cycles that disrupt forecasting, investment planning, and margin stability.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "ESG Compliance",
      text: "Stricter regulatory expectations demand better reporting, waste control, carbon reduction, and community impact accountability.",
    },
    {
      icon: "/assets/icons/operations.png",
      title: "Operational Inefficiencies",
      text: "Aging assets, unpredictable downtime, and manual monitoring reduce output and drive up operational expenses.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/risk.png",
      title: "Price Hedging",
      text: "We build structured frameworks and cost-risk models that stabilize revenues and protect long-term profitability.",
    },
    {
      icon: "/assets/icons/sustainability.png",
      title: "Sustainable Frameworks",
      text: "Our ESG roadmaps integrate emissions tracking, responsible sourcing, and compliance-driven improvements across the mine lifecycle.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Digital Mines",
      text: "We deploy analytics, automation, and predictive maintenance models to reduce costs and elevate workforce safety.",
    },
  ],
};

// ==========================
// HEALTHCARE DATA
// ==========================
export const healthcareData = {
  mainTitle: "HEALTHCARE CHALLENGES & PRACTICAL SOLUTIONS",
  mainSubtitle:
    "Guiding healthcare organizations through rising costs, digital gaps, and regulatory complexity.",

  leftTitle: "Industry Challenges",
  rightTitle: "Our Solutions",

  challenges: [
    {
      icon: "/assets/icons/cost.png",
      title: "Rising Costs",
      text: "Increasing operational expenses, workforce shortages, and supply-chain disruptions erode margins.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Digital Lag",
      text: "Outdated systems limit efficiency and slow down clinical decision-making.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Compliance Pressure",
      text: "Healthcare providers face tightening regulatory frameworks and reporting requirements.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Cost Reform",
      text: "Financial models simplify expenditures, improve resource allocation, and protect long-term success.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Digital Integration",
      text: "Implementing modern EHRs, intelligent automation, and data tools that improve speed & accuracy.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Regulatory Alignment",
      text: "Building strong compliance processes with full visibility and reduced audit risk.",
    },
  ],
};

export const lifeScienceData = {
  mainTitle: "INDUSTRY PRESSURE & SCIENCE-READY SOLUTIONS",
  mainSubtitle:
    "Addressing the scientific, regulatory, and financial hurdles shaping tomorrow.",

  leftTitle: "Industry Challenges",
  rightTitle: "Our Solutions",

  challenges: [
    {
      icon: "/assets/icons/clock.png",
      title: "Slow Clinical Timelines",
      text: "Complex protocols, recruitment gaps, and rising operational costs often delay clinical milestones.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Regulatory Complexity",
      text: "Frequent guideline updates and varying regional requirements make approval planning difficult.",
    },
    {
      icon: "/assets/icons/market.png",
      title: "Market Access Pressure",
      text: "Increasing payer scrutiny makes launching new therapies both costly and uncertain.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/digital.png",
      title: "Trial Acceleration",
      text: "We redesign workflows, optimize site strategy, and incorporate digital tools to shorten timelines.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Compliance Clarity",
      text: "We provide structured regulatory roadmaps that simplify submissions and reduce approval risks.",
    },
    {
      icon: "/assets/icons/strategy.png",
      title: "Value Strategy",
      text: "We build pricing and reimbursement frameworks that improve acceptance and long-term market viability.",
    },
  ],
};
export const privateEquityData = {
  mainTitle: "INVESTMENT PRESSURES & MEASURED SOLUTIONS",
  mainSubtitle:
    "Addressing the realities of modern private equity with insight-driven, execution-ready strategies.",

  leftTitle: "Industry Challenges",
  rightTitle: "Our Solutions",

  challenges: [
    {
      icon: "/assets/icons/margin.png",
      title: "Valuation Volatility",
      text: "Fluctuating markets and inconsistent earnings quality make deal pricing increasingly complex.",
    },
    {
      icon: "/assets/icons/utilization.png",
      title: "Slow Value Creation",
      text: "Portfolios often face operational gaps, limited visibility, and inconsistent execution during the first 12–18 months.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Exit Uncertainty",
      text: "Shifting buyer expectations and regulatory scrutiny increase the risk of underperforming exits.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Price Discipline",
      text: "We build valuation models rooted in scenario forecasting, cash flow sensitivity, and industry-specific benchmarks.",
    },
    {
      icon: "/assets/icons/workforce.png",
      title: "Rapid Value Plans",
      text: "We develop 100-day transformation blueprints, governance fixes, and digital accelerators that create measurable impact quickly.",
    },
    {
      icon: "/assets/icons/automation.png",
      title: "Exit Optimization",
      text: "We validate performance metrics, reduce operational red flags, and prepare assets for a smoother, higher-value exit.",
    },
  ],
};


export const professionalServiceData = {
  mainTitle: "PROFESSIONAL CHALLENGES & PRACTICAL SOLUTIONS",
  mainSubtitle:
    "Supporting firms as they navigate pricing pressure, operational gaps, and digital maturity challenges.",

  leftTitle: "Industry Challenges",
  rightTitle: "Our Solutions",

  challenges: [
    {
      icon: "/assets/icons/margin.png",
      title: "Margin Pressure",
      text: "Intense competition, rising delivery costs, and inconsistent pricing models continue to shrink firm profitability.",
    },
    {
      icon: "/assets/icons/utilization.png",
      title: "Utilization Gaps",
      text: "Poor forecasting, uneven workloads, and skill mismatches reduce billable hours and weaken delivery efficiency.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Digital Underperformance",
      text: "Legacy tools, fragmented data, and limited automation slow down decision-making and impact project outcomes.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Margin Resilience",
      text: "Creating pricing frameworks, cost models, and engagement controls that protect profitability and improve revenue quality.",
    },
    {
      icon: "/assets/icons/workforce.png",
      title: "Workforce Optimization",
      text: "Implementing capacity planning, utilization tracking, and talent alignment to maintain delivery consistency and productivity.",
    },
    {
      icon: "/assets/icons/automation.png",
      title: "Digital Modernization",
      text: "Deploying automation, integrated workflows, and real-time dashboards that improve visibility and accelerate operations.",
    },
  ],
};

export const publicSectorData = {
  mainTitle: "PUBLIC PRESSURES. SMARTER RESPONSES.",
  mainSubtitle:
    "Address budget constraints, operational inefficiencies, and digital transformation gaps.",

  leftTitle: "Industry Challenges",
  rightTitle: "Our Solutions",

  challenges: [
    {
      icon: "/assets/icons/budget.png",
      title: "Budget Constraints",
      text: "Shrinking budgets and rising operational demands limit service quality and restrict long-term planning.",
    },
    {
      icon: "/assets/icons/process.png",
      title: "Slow Processes",
      text: "Lengthy workflows, paper-heavy operations, and isolated departments delay service delivery.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Digital Backlogs",
      text: "Legacy systems and low digital adoption lead to errors, delays, and weak data visibility.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/financial.png",
      title: "Financial Optimization",
      text: "Building clearer financial models and improving allocation strategies for better public value.",
    },
    {
      icon: "/assets/icons/process.png",
      title: "Process Redesign",
      text: "Simplifying operations, improving interdepartmental coordination, and reducing turnaround times.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Digital Integration",
      text: "Modernizing infrastructure, deploying e-governance tools, and enabling real-time analytics for faster decisions.",
    },
  ],
};

export const realEstateConstructionData = {
  mainTitle: "CONSTRUCTION COMPLEXITY, SIMPLIFIED",
  mainSubtitle: "We aim to help developers and contractors manage rising costs.",

  leftTitle: "Industry Challenges",
  rightTitle: "Our Solutions",

  challenges: [
    {
      icon: "/assets/icons/cost.png",
      title: "Cost Overruns",
      text: "Different material prices, change orders, and weak procurement visibility push projects beyond budget.",
    },
    {
      icon: "/assets/icons/delivery.png",
      title: "Delivery Delays",
      text: "Poor coordination, subcontractor inconsistency, and fragmented workflows create project slowdowns.",
    },
    {
      icon: "/assets/icons/operations.png",
      title: "Operational Fragmentation",
      text: "Multiple stakeholders, separate teams, and manual reporting lead to visibility gaps and higher risk.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/cost.png",
      title: "Cost Discipline",
      text: "Strengthening financial tracking, procurement control, and forecasting models protect margins.",
    },
    {
      icon: "/assets/icons/delivery.png",
      title: "Delivery Optimization",
      text: "Scheduling implementation, oversight dashboards, and integrated workflows maintain delivery predictability.",
    },
    {
      icon: "/assets/icons/governance.png",
      title: "Integrated Governance",
      text: "Establishing unified reporting, cross-team alignment, and governance frameworks offer smoother delivery.",
    },
  ],
};

export const mediaEntertainmentData = {
  mainTitle: "MEDIA CHALLENGES & PRACTICAL SOLUTIONS",
  mainSubtitle:
    "Helping media companies navigate platform shifts and rising production uncertainty.",

  leftTitle: "Industry Challenges",
  rightTitle: "Our Solutions",

  challenges: [
    {
      icon: "/assets/icons/margin.png",
      title: "Content Overload",
      text: "Audiences are scattered across platforms, making it harder to fund content.",
    },
    {
      icon: "/assets/icons/utilization.png",
      title: "Rising Production Costs",
      text: "Tight timelines, talent costs, and unpredictable execution destroy profitability.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Monetization Fragmentation",
      text: "Advertising, OTT, and combined revenues fluctuate across platforms and regions.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Content ROI Mapping",
      text: "Building models that identify high-performance formats, genres, and markets for smarter investment.",
    },
    {
      icon: "/assets/icons/workforce.png",
      title: "Smart Production Planning",
      text: "Implementing cost controls, vendor alignment, and workflow redesign to protect margins.",
    },
    {
      icon: "/assets/icons/automation.png",
      title: "Revenue System Integration",
      text: "Creating flexible monetization architectures with clearer reporting and pricing discipline.",
    },
  ],
};
export const technologyData = {
  mainTitle: "TECH CHALLENGES & CLEAR SOLUTIONS",
  mainSubtitle:
    "Supporting tech leaders through intense competition and rising costs.",

  leftTitle: "Industry Challenges",
  rightTitle: "Our Solutions",

  challenges: [
    {
      icon: "/assets/icons/margin.png",
      title: "Feature Overload",
      text: "Teams build too much, too fast, with unclear priorities.",
    },
    {
      icon: "/assets/icons/utilization.png",
      title: "Scaling Strain",
      text: "As teams grow, delivery slows, processes break, and burnout increases.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Rising Digital Costs",
      text: "Cloud spend, tools, and engineering resources stretch margins.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Product Focus",
      text: "Sharper decision frameworks to reduce noise and accelerate meaningful releases.",
    },
    {
      icon: "/assets/icons/workforce.png",
      title: "Operational Refinement",
      text: "Cleaner workflows, better team structures, and smarter delivery rhythms.",
    },
    {
      icon: "/assets/icons/automation.png",
      title: "Cost Visibility",
      text: "Clearer spend insights, optimized usage, and leaner engineering operations.",
    },
  ],
};
export const telecommunicationData = {
  mainTitle: "CONNECTIVITY DEMANDS & PRACTICAL SOLUTIONS",
  mainSubtitle:
    "Supporting telecom operators as they navigate regulatory pressure and customer expectations.",

  leftTitle: "Industry Challenges",
  rightTitle: "Our Solutions",

  challenges: [
    {
      icon: "/assets/icons/margin.png",
      title: "High Network Costs",
      text: "4G/5G networks, fibre expansion, and asset maintenance continue to strain operating margins.",
    },
    {
      icon: "/assets/icons/utilization.png",
      title: "Customer Churn",
      text: "Price wars and inconsistent service quality push customers to switch rapidly.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Regulatory Pressure",
      text: "Operators face evolving spectrum rules, compliance demands, and competition regulations.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Cost Efficiency",
      text: "Redesigning investment models, vendor strategies, and infrastructure planning to control capex and opex.",
    },
    {
      icon: "/assets/icons/workforce.png",
      title: "Experience Upgrade",
      text: "Enhancing service journeys, digital touchpoints, and reliability to reduce churn.",
    },
    {
      icon: "/assets/icons/automation.png",
      title: "Regulatory Alignment",
      text: "Building frameworks that ensure transparency, compliance readiness, and smoother audit outcomes.",
    },
  ],
};

